import React, { useEffect } from "react";
import { Grid, TextField, Typography, Box, useTheme } from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const BgrManualForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = "#C62828";

  // Always enforce hidden defaults
  useEffect(() => {
    if (config.processor !== "vumo") onChange("processor", "vumo");
    if (config.processRoof !== false) onChange("processRoof", false);
  }, []);

  // Auto-generate apiEndpoint based on profile
  useEffect(() => {
    console.log(config)
    const profile = config.profile || "default_detail";
    let apiEndpoint = `https://api.vumography.vumo.ai/api/v1/process/single/${profile}`;

    // Special case: compensation profile uses dual endpoints
    if (profile === "platform_30_off_roll_compensation_car_crop_09") {
      apiEndpoint =
        "https://api.vumography.vumo.ai/api/v1/process/single/platform_30_off_roll_compensation_car_crop_09, https://api.vumography.vumo.ai/api/v1/process/single/platform_30_static_image";
    }

    if (config.apiEndpoint !== apiEndpoint) {
      onChange("apiEndpoint", apiEndpoint);
    }
  }, [config.profile]);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderLeft: `3px solid ${red}`,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        Background Replace Manual Images
      </Typography>

      <Grid container spacing={2}>
        {/* Only editable field */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Profile"
            fullWidth
            value={config.profile || ""}
            onChange={(e) => onChange("profile", e.target.value)}
            variant="outlined"
            InputLabelProps={{ style: { color: "#aaa" } }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
              "& .MuiInputBase-input": { color: "#fff" },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BgrManualForm;
